import { Component, OnInit, Inject } from '@angular/core';
import { ContactService } from '../../contact.service';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-demo-videos',
  templateUrl: './demo-videos.component.html',
  styleUrls: ['./demo-videos.component.scss']
})
export class DemoVideosComponent implements OnInit {
  demovideos = [
    {title : "How to Delete a Vehicle Permanently",videoLink:  "https://drive.google.com/file/d/16DVKAOwTzwFVVtWHqu8X96V9WIJob84q/preview"},
    {title : "How to shift Vehicle into same Dealer",videoLink:  "https://drive.google.com/file/d/154KP2n5oW0o_80AAm3Ph8lT2tnrrQkT8/preview"},
    {title : "How to create a geofence and assign Vehicle into it",videoLink:  "https://drive.google.com/file/d/1C5BMKdp_p6hwvbYQ8ysDgql-BIFxzblb/preview"}, 
    {title : "How to add new customer/user and add Vehicle into it",videoLink:  "https://drive.google.com/file/d/16XggTWEVsihFyxGzvM4DPVHd-d6j83Nz/preview"},
    {title : "How to check live history of a Vehicle",videoLink:  "https://drive.google.com/file/d/1RmhnHRewaLV9zby-vHnPcnj-JsAiwhP6/preview"},
    {title : "How to Driver's Detail to a Vehicle",videoLink:  "https://drive.google.com/file/d/1ltHsFnFNfgZpdz58h-ryyMV-HZGggmOa/preview"},
    {title : "How to check system log of a Vehicle",videoLink:  "https://drive.google.com/file/d/1azN3zHdcG0gyIKZgvlbvmyHy4v-R91Eb/preview"},

  ]

  constructor(private contactService: ContactService,private router: Router,private _flashMessagesService: FlashMessagesService,public dialogRef: MdDialogRef<DemoVideosComponent>,
    @Inject(MD_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    // localStorage.setItem('demovideo','false');

  }

  close(){
    this.dialogRef.close();

  }
}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/const/demo-videos/demo-videos.component.ts